import React from 'react';
import {useFormikContext} from "formik";
import {formatPhoneNumberIntl} from "react-phone-number-input";
import {CurrencyFormat} from "../../../../../utils/CurrencyFormat";
import {Divider} from "@mantine/core";
import './SolicitudForm.css'

export default function SolicitudForm() {
    const {values} = useFormikContext();
    return (
        <React.Fragment>

            <p className="form__text--primary" style={{textAlign:"start"}}>
                Datos del vehículo:
            </p>
            <Divider my="sm" size="xs"/>
            <div className="form__body--noMarginTop">
                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">Vehículo:</p>
                    <p className="form__text--light">{values.motovehiculo.marca} {values.motovehiculo.nombreModelo} {values.motovehiculo.anio}</p>
                </div>

                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">Patente:</p>
                    <p className="form__text--light">{values.motovehiculo.patente}</p>
                </div>
                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">Valor vehículo:</p>
                    <p className="form__text--light">${CurrencyFormat(values.motovehiculo.valor)}</p>
                </div>
            </div>

            <p className="form__text--primary structure__margin--topOnly" style={{textAlign:"start"}}>
                Datos del asegurado:
            </p>
            <Divider my="sm" size="xs"/>

            <div className="form__body--noMarginTop">
                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">Nombre:</p>
                    <p className="form__text--light">{values.nombre} {values.apellido}</p>
                </div>
                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">DNI:</p>
                    <p className="form__text--light">{values.dni}</p>
                </div>
                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">Celular:</p>
                    <p className="form__text--light">{formatPhoneNumberIntl(values.telefono)}</p>
                </div>
                <div className="structure__margin--topXS structure__columnToRow--centered">
                    <p className="form__text--dark">E-mail:</p>
                    <p className="form__text--light">{values.email}</p>
                </div>
            </div>

            <div className="structure__margin--topOnly">
                <div className="form__price">
                    <p className="form__subtitle--white">Cuota mensual:</p>
                    <p className="form__title--white">$ {CurrencyFormat(values.premium.toFixed(0))}</p>
                </div>
            </div>
        </React.Fragment>
    );
}
